<template>
    <ul class="d-flex">
        <li v-for="item in side_bar_data" :key="item.tittle">
            <ul class="d-flex">
                <template v-for="menu in item.menu" :key="menu.menuValue">
                    <li v-if="!menu.hasSubRoute && user?.permissions?.includes(menu.menuValue)" :title="menu.menuValue"
                        :class="{ active: isMenuActive(menu) }" class="me-1 me-xxl-2">
                        <router-link :to="menu.route" @click="expandSubMenus(menu)" :class="{
                            active:
                                currentPath === menu.active_link ||
                                currentPath === menu.active_link1 ||
                                currentPath === menu.active_link2 ||
                                currentPath === menu.active_link3 ||
                                currentPath === menu.active_link4,
                        }">
                            <i :class="'ti-' + menu.icon" v-if="menu.icon === 'bar-chart'"></i>
                            <i class="ti" :class="'ti-' + menu.icon" v-else></i>
                            <!-- <span>{{ menu.menuValue }}</span> -->
                        </router-link>
                    </li>
                    <li v-if="menu.hasSubRoute && user?.permissions?.includes(menu.menuValue) && menu.menuValue === 'ELECTRALINK'" :title="menu.menuValue"
                        :class="{ active: isMenuActive(menu) }" class="me-1 me-xxl-2">
                        <router-link :to="menu.route" @click="expandSubMenus(menu)" :class="{
                            active:
                                currentPath === menu.active_link ||
                                currentPath === menu.active_link1 ||
                                currentPath === menu.active_link2 ||
                                currentPath === menu.active_link3 ||
                                currentPath === menu.active_link4,
                        }">
                            <i :class="'ti-' + menu.icon" v-if="menu.icon === 'bar-chart'"></i>
                            <i class="ti" :class="'ti-' + menu.icon" v-else></i>
                            <!-- <span>{{ menu.menuValue }}</span> -->
                        </router-link>
                    </li>
                    <li v-if="!menu.hasSubRoute && user.roles?.[0] === 'super_admin' && menu.menuValue === 'Support'"
                        :title="menu.menuValue" :class="{ active: isMenuActive(menu) }">
                        <router-link :to="menu.route" @click="expandSubMenus(menu)" :class="{
                            active:
                                currentPath === menu.active_link ||
                                currentPath === menu.active_link1 ||
                                currentPath === menu.active_link2 ||
                                currentPath === menu.active_link3 ||
                                currentPath === menu.active_link4,
                        }">
                            <i :class="'ti-' + menu.icon" v-if="menu.icon === 'bar-chart'"></i>
                            <i class="ti" :class="'ti-' + menu.icon" v-else></i>
                            <!-- <span>{{ menu.menuValue }}</span> -->
                        </router-link>
                    </li>

                    <li v-if="!menu.hasSubRoute && menu.route &&
                        menu.route === '/companies' &&
                        user.roles?.[0] === 'super_admin'" :class="{ active: isMenuActive(menu) }"
                        :title="menu.menuValue" class="me-3">
                        <router-link :to="menu.route" @click="expandSubMenus(menu)"><i :class="'ti-' + menu.icon"
                                v-if="menu.icon === 'bar-chart'"></i><i class="ti" :class="'ti-' + menu.icon"
                                v-else></i>
                            <!-- <span>{{ menu.menuValue }}</span> -->
                        </router-link>
                    </li>
                </template>
            </ul>
        </li>
    </ul>
</template>

<script>
import side_bar_data from "@/assets/json/sidebar-data.json";
import { mapGetters, mapActions } from "vuex";

export default {
    data() {
        return {
            side_bar_data: side_bar_data,
            showSubRoute: null,
            route_array: [],
            multilevel: [false, false, false],
        };
    },
    methods: {
        ...mapActions("auth", ["loadUserFromLocalStorage"]),
        expandSubMenus(menu) {
            this.side_bar_data.forEach((item) => {
                if (item.menu && Array.isArray(item.menu)) {
                    item.menu.forEach((subMenu) => {
                        if (subMenu !== menu) {
                            subMenu.showSubRoute = false;
                            subMenu.showSubRoute1 = false;
                        }
                    });
                }
            });
            menu.showSubRoute = !menu.showSubRoute;
        },

        getCurrentPath() {
            this.route_array = this.$route.path.split("/");
            return this.$route.path;
        },
    },
    computed: {
        ...mapGetters("auth", ["user"]),
        currentPath() {
            return this.getCurrentPath();
        },
        isMenuActive() {
            return (menu) => {
                if (menu.menuValue === "Application") {
                    return (
                        this.$route.path.startsWith("/application") || // Check if current route starts with '/application'
                        this.$route.path.startsWith("/call") ||
                        this.$route.path === menu.active_link ||
                        this.$route.path === menu.active_link1 ||
                        this.$route.path === menu.active_link2
                    );
                } else {
                    return (
                        this.$route.path === menu.route ||
                        this.$route.path === menu.active_link ||
                        this.$route.path === menu.active_link1 ||
                        this.$route.path === menu.active_link2 ||
                        this.$route.path === menu.active_link3 ||
                        this.$route.path === menu.active_link4 ||
                        this.$route.path === menu.active_link5 ||
                        this.$route.path === menu.active_link6 ||
                        this.$route.path === menu.active_link7 ||
                        this.$route.path === menu.active_link8 ||
                        this.$route.path === menu.active_link9 ||
                        this.$route.path === menu.active_link10 ||
                        this.$route.path === menu.active_link11
                    );
                }
            };
        },
    },
};
</script>
<style lang="scss" scoped>
.sidebar-horizontal {
    ul {
        li {
            a {
                display: flex;
                align-items: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                font-weight: 400;
                font-size: 14px;
                color: #6F6F6F;
                position: relative;
                width: 100%;
                padding: 8px;

                span {
                    font-size: 14px;
                    font-weight: 500;
                    white-space: nowrap;
                    color: #262A2A;
                    margin-left: 8px;
                }

                i {
                    color: #262a2a;
                    font-size: 14px;
                    background: #f6f6f6;
                    border-radius: 5px;
                    width: 21px;
                    height: 21px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                &.active {
                    color: #E41F07;
                    background: #FCE9E6;
                    border-radius: 5px;
                    border-bottom: 2px solid #E41F07;

                    i {
                        background: #E41F07;
                        color: #FFF;
                    }
                }
            }
        }
    }
}
</style>